import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Назад',
      changePassword: 'Промяна',
      copiedVaultId: 'Копирано!',
      copyVaultID: 'Копиране на ID на Vault',
      create: 'Създаване',
      next: 'Напред',
      notSure: 'Не съм сигурен(а).',
      signUp: 'Регистрирайте се',
      submit: 'Изпращане',
      updatePassword: 'Актуализирай парола',
    },
    Errors: {
      createReportFailed: 'Неуспешно създаване на сигнал.',
    },
    ReportStatus: {
      CLOSED: 'Приключен',
      INVESTIGATING: 'Разследван',
      NEW: 'Изпратен',
      READ: 'Прочетен',
    },
    general: {
      navbar: {
        caseSettings: 'Настройки на калъфа',
        changePassword: 'Смени парола',
        logOut: 'Изход',
        notifications: 'Известия',
        notificationsDrawer: {
          appFileScanFailed: 'Файлът не успя да премине сигурностната проверка',
          appReportMatch: 'Вашият запис в GoTogether е съвпаднал',
          appReportReassigned: 'Нов управител на случаи е бил назначен',
          case: 'Случай',
          caseAssigned: 'Случайът е възложен на вас',
          caseImporterJobCompleted: {
            PartialSuccess: 'Импортирането на вашия случай приключи с грешки',
            failure: 'Вносът на вашия случай се провали',
            success: 'Импортирането на вашия случай приключи успешно',
          },
          caseLinked: 'Свързан случай',
          caseTeamInvite: 'Добавено към дело',
          caseUnlinked: 'Случайът е разкачен',
          dataSanitisation: 'Детайли за отчета са актуализирани',
          emptyDescription: 'Проверете по-късно за нови известия',
          emptyTitle: 'Вие сте напълно информирани',
          importId: 'Импортиране на ID:',
          learnMore: 'Научи повече',
          markAllAsRead: 'Маркирай всички като прочетени',
          newMessage: 'Ново съобщение',
          newReport: 'Получен нов доклад',
          permissionRemoved: 'Премахнат от делото',
          postSSubmissionFile: 'Добавени доказателствени файл(ове)',
          report: 'Доклад',
          reportAssigned: 'Докладът е възложен на вас',
          reportStatusChange: 'Статусът на доклада е променен',
          reporterAnonymised: 'Вашите данни са били анонимизирани',
          reporterReportSubmitted: {
            subtitle: 'Препоръчваме да запазите копие от вашия доклад',
            title: 'Подаден доклад',
          },
          mitigationPlanReminder:
            'Необходимо е одобрение на плана за намаляване',
          staleCase: 'Недействан случай',
        },
        privacyStatement: 'Декларация за поверителност',
        reporter: {
          myReports: 'Моите доклади',
        },
        settings: 'Настройки',
        technicalSupport: 'Техническа поддръжка',
        title: 'Акаунт',
      },
      time: {
        day: 'Ден',
        days: 'Дни',
        hour: 'Час',
        hours: 'Часове',
        minute: 'Минута',
        minutes: 'Минути',
        second: 'Секунда',
        seconds: 'Секунди',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Анонимен',
        autoTranslate: 'Автоматичният превод е изключен по подразбиране.',
        backToMessages: 'Назад към съобщенията',
        caseSettings: 'Настройки на казуса.',
        changeInProfile:
          'Ако желаете да промените тази настройка, можете да го направите във вашия профил',
        deletedByMessage: 'Изтрито от {{author}}',
        deletedMessageLabel: 'Това съобщение беше изтрито',
        description:
          'Когато автоматичният превод е включен, всички съобщения за доклади ще бъдат\n          автоматично преведени чрез изкуствен интелект въз основа на езика по подразбиране,\n          избран на вашия браузър.',
        descriptionSecondHalf:
          'Оригиналната версия на всички съобщения винаги се запазва и може да бъде намерена в чата.',
        messagePlaceholder: 'Започнете да пишете...',
        messageSettings: 'Настройки за съобщения.',
        originalMessages: 'Оригинал',
        showMoreBanner: 'Научете повече за автоматичните преводи',
        titlev2: 'Прочетете всички съобщения на предпочитания от вас език.',
        translatedMessageLabel: 'Преведено съобщение',
        translatedMessages: 'Преведено',
        understood: 'Разбрано',
      },
      Country: {
        description: 'В коя държава работите?',
        header: 'В коя държава работите?',
        noOptions: 'Няма намерени държави',
        other: 'Друго',
        placeholder: 'Търсете държава...',
      },
      CreatePublicReport: {
        createReport: 'Създаване на сигнал',
        helpPage: 'Отидете на нашата страница за помощ',
        loginToOpr: 'Вход за проследяване на сигнали',
        or: 'или',
        passwordPlaceholder: 'Въведете парола',
        phoneNumberLoginFailed: 'Неуспешно влизане, грешен телефонен номер/PIN',
        phoneNumberPlaceholder: 'Въведете телефонния си номер',
        phoneNumberTooltip:
          'Въведете телефонния номер, който сте използвали, за да се свържете с VaultTalk',
        pinPlaceholder: 'Въведете PIN',
        reportIntroductionParagraph1:
          'При докладване на инцидент ще Ви бъдат зададени няколко въпроса, които да Ви помогнат да документирате случая.',
        reportIntroductionParagraph2:
          'Преди да изпратите, имате възможност да останете анонимни, за да защитите личните си данни.',
        reportIntroductionParagraph3:
          'След изпращане можете да влизате по всяко време, за да видите напредъка по сигнала си и за да разговаряте със служител по случая.',
        reportIssue: 'Докладване на проблем',
        usernameLoginFailed:
          'Влизането е неуспешно, грешно потребителско име/парола',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired: 'Изисква се връзка с компанията',
            reportedCategoryRequired: 'Изисква се докладвана категория',
          },
        },
        vaultId: 'ID във Vault',
        vaultIdPlaceholder: 'Въведете своя имейл или ID във Vault',
        vaultIdTooltip:
          'За анонимни сигнали ID във Vault съдържа букви и цифри. Ако сигналът не е анонимен, ID във Vault е Вашият имейл адрес',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Вашата парола',
        yourPhoneNumber: 'Вашият телефонен номер',
        yourPin: 'Вашият 6-цифрен PIN',
        yourVaultId: 'Вашият ID във Vault',
      },
      CustomHeader: {
        companyLogo: 'Лого на {{company}}',
        openReporting: 'Открито подаване на сигнал',
        userSettings: 'Настройки на потребителя',
      },
      Date: {
        approximateDescription:
          'Спомняте ли си приблизителната дата, на която се е случило събитието?',
        approximatePlaceholder:
          'Пример: преди 6 месеца/миналата година/миналия ноември',
        cancel: 'отмяна',
        clear: 'изчистване',
        description: 'Спомняте ли си датата на събитието?',
        header: 'В кой ден се случи?',
        ok: 'ОК',
        placeholder: 'Пример: 21 юни 2020 г.',
      },
      Description: {
        whatHappened: 'Какво се случи?',
        whatHappenedPlaceholder: 'Използвайте свои думи...',
        whatHappenedText: 'Опишете със свои думи какво се е случило',
      },
      Details: {
        disclaimer:
          'Тези данни ще бъдат оповестени в сигнала Ви. Ако желаете да запазите анонимност, погрижете се да не съдържат информация за самоличността Ви.',
        emailPlaceholder: 'Имейл (незадължителен)',
        fullNamePlaceholder: 'Име, презиме, фамилия (незадължително)',
        header: 'Вашите данни',
        nonAnonSubtitle:
          'Моля, предоставете име или имейл адрес. Ако искате да получавате известия за този доклад, добавете подходящ имейл адрес по-долу.',
        nonOptionalEmailPlaceholder: 'Имейл',
        nonOptionalFullNamePlaceholder: 'Пълно име',
        subtitle:
          'Ако желаете да получавате известия по този сигнал, добавете подходящ имейл адрес по-долу.',
      },
      Emotion: {
        description: 'Как се почувствахте? Какви бяха последиците?',
        header: 'Какви бяха последиците?',
        placeholder: 'Започнете да пишете...',
      },
      Evidence: {
        addedHeading: 'Добавени',
        deletedMessage: 'беше изтрит',
        deletedStatus: 'Изтрит',
        failedToOpenFileMessage:
          'Неуспешно отваряне на файла. Моля, опитайте отново',
        fileStatuses: {
          infectedUpload: 'Отбелязано от проверка за сигурност',
          passedUpload: 'Успешно преминаване на проверката за сигурност',
          pendingUpload: 'В процес на проверка за сигурност',
          readyForDownload: 'Готови за изтегляне',
        },
        mobileErrorMessage:
          'Отбелязани файлове: изпратете съобщение до служителя по Вашия случай',
        nameHeading: 'Име',
        statusHeading: 'Статус',
        tableTitle: 'Доказателства',
        webErrorMessage:
          'Отбелязани файлове: Ако файла(овете) Ви са отбелязани, изпратете съобщение до служителя по случая',
      },
      FileUpload: {
        addFiles: 'Добавяне на файлове',
        addMoreFiles: 'Добавяне на още файлове',
        confirm: 'Потвърждаване',
        description:
          'Добавянето на файлове като доказателства може да помогне за ефективното разрешаване на случая от служителя по Вашия случай. Моля, съобразете съдържанието на файловете (включително метаданните им), ако желаете да запазите анонимност, и зачитайте правата на останалите лица и приложимите закони.',
        dragDrop: 'Пуснете файловете тук или',
        errorMessage:
          'Неуспешно качване на файл(ове) поради грешка в мрежата. Щракнете по-долу, за да изпратите съобщение на служителя по Вашия за помощ',
        fileLimit: 'Ограничение за размера на всеки файл: 100 MB',
        fileUploadLimitText: 'Можете да качите само 10 файла',
        header: 'Добавяне на доказателства',
        helpArticle: 'помощна статия',
        highlighted: 'преглеждане на файлове',
        information: 'Поддържани типове файлове',
        moreInformation:
          'За повече информация вижте това <a>помощна статия</a>',
        postSubmissionErrorMessage:
          'Не успяхме да качим файловете Ви поради системна грешка. Моля, изберете отново „потвърди“.',
        tooltipAudio: 'Аудиозапис:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Документи:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Снимки:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Текст:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Видео:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Файлът е твърде голям',
          invalidFileType: 'Неподдържан тип файл: {{extension}}',
          systemError: 'Системна грешка',
          tooManyFiles: 'Максималният брой файлове е {{maxFiles}}',
        },
        uploadFiles: 'Качване на файлове',
      },
      Loading: {
        loading:
          'Моля, изчакайте, докато предадем сигнала Ви на служител по случаи...',
        postSubmissionLoading:
          'Моля, изчакайте, докато изпратим Вашия(ите) файл(ове)...',
      },
      Location: {
        description: 'Къде се случи?',
        header: 'Къде се случи?',
        placeholder: 'Пример: в офиса',
      },
      MessageListBox: {
        messageCaseManager: 'Съобщение до служителя по случая',
        report: 'Сигнал {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Преводът е деактивиран',
        enableTranslationLabelEnabled: 'Преводът е активиран',
        enableTranslationsDescription:
          'Активирайте автоматичните преводи и прочетете всички съобщения от доклада на предпочитания от вас език. Преведеният език се базира на езика, избран на вашето устройство.',
        enableTranslationsHeader:
          'Активирайте автоматични преводи за съобщения от доклади',
        enableTranslationsSubDescriptionv2:
          'Можете да превключвате между преведения и оригиналния език във всяка чат стая.',
        updateTranslationFailed: 'Актуализацията на превода не бе успешна',
        updateTranslationSuccess:
          'Настройката за превод е актуализирана успешно',
      },
      Password: {
        changePasswordHeader: 'Промяна',
        createNewPassword: 'Моля, създайте нова парола',
        createPasswordHeader: 'Вашата парола',
        currentPasswordPlaceholder: 'Въведете текущата парола',
        description:
          'За да бъде валидна, паролата трябва да съдържа поне 9 символа и да включва една главна буква и една цифра',
        enterCurrentPassword: 'Моля, въведете текущата си парола',
        forgottenPasswordInstructions:
          'Въведете вашия алфанумеричен Vault ID (не вашия имейл адрес) и имейл адрес, за да възстановите вашата парола.',
        newDescription:
          'Създайте силна парола, за да поддържате акаунта си в безопасност. Започнете да пишете, за да видите насоките по-долу.',
        passwordPlaceholder: 'Създаване на парола',
        passwordResetRequestedDescription:
          'Ако вашето Vault ID съществува в нашата система, ще получите имейл с инструкции за възстановяване на паролата си.',
        passwordResetRequestedHeader: 'Заявена връзка за нулиране на парола',
        reenterPlaceholder: 'Въведете отново паролата',
        subtitle:
          'Създайте парола за подаване на този сигнал и за достъп до него в бъдеще',
        yourVaultId: 'Вашият Vault ID',
        yourVaultIdPlaceholder: 'Въведете вашия Vault ID (напр. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Подавате ли сигнал за конкретно лице или лица? Можете ли да ги назовете по име или да ги опишете?',
        header: 'Хора, участващи',
        placeholder:
          'Започнете да пишете и използвайте запетая, за да добавите повече от едно имена или описания',
      },
      PoweredByVault: 'Поддържано от {{company}}',
      PrivacyStatement: 'Декларация за поверителност на продукта',
      PublicMessageList: {
        myMessages: 'Моите съобщения',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader:
          'Добавени доказателства към съществуващ сигнал',
        backToReportId: 'Обратно към ID на сигнала: {{reportId}}',
        description:
          'Добавянето на файлове като доказателства може да помогне за ефективното разрешаване на случая от служителя по Вашия случай. Моля, съобразете съдържанието на файловете (включително метаданните им), ако желаете да запазите анонимност, и зачитайте правата на останалите лица и приложимите закони. За повече информация, вижте това <a>помощна статия</a>',
        header: 'Добавяне на допълнителни доказателства към сигнала',
        vaultTalkOpenCaseHeader: 'Добавяне на доказателства към сигнала',
      },
      PublicReport: {
        anonymous: 'Анонимен',
        backToReports: 'Обратно към сигнали',
        skipped: 'Пропуснат',
      },
      PublicReportCard: {
        addEvidence: 'Добавяне на допълнителни доказателства',
        messageCaseManager: 'Съобщение до служителя по случая',
        reportId: 'ID на сигнала:',
        submitted: 'Изпратен',
        vaultTalkClosedCaseCTA: 'Преглед на доказателства',
        vaultTalkOpenCaseCTA: 'Добавяне на доказателства',
        viewAdditionalEvidence: 'Преглед на допълнителни доказателства',
        viewReport: 'Преглед на сигнал',
      },
      PublicReportsList: {
        reportingSystem: 'Система за подаване на сигнали',
      },
      Question: {
        placeholder: 'Започнете да пишете...',
        question: 'Предоставяне на информация',
        questionText:
          'Моля, споделете Вашите опасения, актуална информация или запитване с нас',
      },
      Relationship: {
        header: 'Връзката Ви с организацията',
        tellUsAbout: 'Моля, разкажете ни за връзката Ви с организацията.',
      },
      ResponsiveNavMenu: {
        messages: 'Моите съобщения',
        reports: 'Моите доклади',
      },
      Site: {
        description: 'В кой обект работите?',
        header: 'В кой обект работите?',
        noOptions: 'Няма намерени обекти',
        other: 'Друго',
        placeholder: 'Търсете обект...',
      },
      SpamPuzzle: {
        dialog: 'За да продължите, решете този пъзел',
      },
      SubmissionTypes: {
        reportIssue: 'Изберете категория',
        whatType: 'Изберете категорията, която описва най-добре сигнала',
      },
      SubmitSuccess: {
        category: '<bold>Категория:</bold> {{category}}',
        country: '<bold>Държава:</bold> {{country}}',
        dateSubmitted: '<bold>Дата на подаване:</bold> {{date}}',
        recordYourVaultID: 'Запомнете тази информация за вход',
        successInformation: 'Повече информация',
        successMessage:
          'Вашият сигнал е подаден и е готов за преглед. Всички прикачени файлове, на които трябва да се обърне внимание, ще бъдат маркирани при влизане в системата. Влезте по-долу, за да видите актуална информация по сигнала и за да изпратите съобщение на служителя по Вашия случай.',
        successSanitationMessage:
          'Запазете копие за своите записи и пазете вашия Vault-ID в безопасност - ще ви трябва, за да получите достъп до актуализации и да изпращате съобщения до вашия управител на случаи.',
        successSanitationTagline:
          'Вашият отчет беше подаден и сигурно съхранен.',
        successThankYou: 'Благодарим Ви за сигнала!',
        viewReport: 'Преглед на сигнал',
      },
      Time: {
        approximateDescription:
          'Спомняте ли си приблизителния час на събитието?',
        approximatePlaceholder: 'Пример: сутрин, следобед',
        description: 'Спомняте ли си часа на събитието?',
        header: 'В колко часа се случи?',
        invalidTime: 'Форматът на часа трябва да бъде ЧЧ:ММ',
      },
      UserSettingsDialog: {
        changePassword: 'Промяна на парола',
        closeDialog: 'Затваряне на диалоговия прозорец',
        logout: 'Излизане',
        messageSettings: 'Настройки за съобщения',
        userSettings: 'Настройки на потребителя',
      },
      Witnesses: {
        description: 'Казахте ли на някого или видя ли някой случилото се?',
        header: 'Има ли свидетели?',
        placeholder: 'Започнете да пишете...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Изпрати съобщение',
        title: 'Съобщение за Мениджър по случаи',
        translationHeader: 'Научете повече за автоматичните преводи',
      },
      ReportCard: {
        addEvidence: 'Добави доказателство',
        submissionModeVia: 'чрез {{submissionMode}}',
        viewEvidence: 'Прегледайте доказателствата',
      },
      ReportList: {
        yourReports: 'Вашите доклади',
      },
      ReportingActivate: {
        buttonText: 'Продължи',
        description:
          'Ако вашата организация ви е регистрирала за акаунт, ще ви изпратим имейл с инструкции за завършване на настройката.',
        emailInput: 'Имейл',
        header: 'Въведете вашия служебен имейл',
        successAccount:
          'Ако вашата организация ви е регистрирала за акаунт, ще ви изпратим имейл с инструкции за завършване на настройката.',
        successEmail:
          'Ако не го видите веднага, моля изчакайте няколко минути и обновете входящата си поща.',
        successHeading: 'Благодаря ви',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Добавете доказателства към доклада си',
        descriptionText:
          'Добавянето на файлове като доказателство може да подпомогне ефективността на решението от вашия управител на случай. Моля, вземете предвид съдържанието на файла (включително метаданните на файла), ако желаете да останете анонимни, и зачитайте правата на другите лица и приложимите закони. За повече информация, моля прегледайте тази <a>помощна статия</a>.',
        emptyMessage: 'Не е качена допълнителна доказателствена информация',
      },
      ReportingChangePassword: {
        back: 'Обратно',
        description:
          'Създайте силна парола, за да поддържате профила си сигурен. Започнете да пишете, за да видите насоките по-долу.',
        errorToast: 'Не може да се създаде парола, невалиден токен.',
        header: 'Смяна на парола',
        incorrectCurrentPassword:
          'Текущата парола е грешна. Моля, проверете я и опитайте отново.',
        invalidToken: 'Невалиден токен',
        passwordUpdated: 'Паролата е обновена',
        passwordUpdatedDescription:
          'Вашата парола беше успешно актуализирана. Благодарим ви, че предприехте тази стъпка, за да поддържате вашите данни в безопасност!',
        passwordUsedBefore: 'Не е разрешено повторното използване на пароли',
        passwordUsedBeforeDescription:
          'За вашата сигурност, не можете да използвате никое от последните си шест пароли. Моля, изберете нова, уникална парола, за да запазите профила си сигурен и опитайте отново.',
        toastDescription:
          'Вашата парола беше успешно обновена. Благодарим ви, че предприехте тази стъпка за да поддържате вашите данни в безопасност!',
        toastMessage: 'Паролата е обновена',
        updatePasswordCTA: 'Актуализирай парола',
      },
      ReportingConnect: {
        cancelButton: 'Отмени',
        connectButton: 'Свържете се',
        disclaimer:
          'Свързването на вашия Slack акаунт с вашия Vault акаунт гарантира сигурна и лична връзка.<br /><br />Свързвайки се, можете да докладвате за нередности или да зададете въпрос директно в Slack. Винаги ще имате възможността да подавате анонимни сигнали след свързване. Вашата лична сигурност и тайна са наши най-високи приоритети.',
        heading:
          'Vault Platform иска разрешение за достъп до вашия Slack акаунт от {{organisationName}}',
        listHeading: 'Какво ще може да прави Vault?',
        permissionIdentity: {
          extraInfo:
            'Vault ще има възможността да вижда идентичността на вашите потребители в Slack.',
          heading: 'Преглед на информация за идентичността на потребител',
        },
        permissionNotifications: {
          extraInfo:
            'Vault ще може да ви изпраща известия на вашия Slack акаунт, относно всички актуализации на подаден доклад или въпрос.',
          heading: 'Изпращам ви известия',
        },
        permissionOverview: {
          extraInfo:
            'Vault ще покаже общ преглед на всички изпратени документи в началната страница',
          heading: 'Преглед на подадените документи',
        },
        permissionSubmitReport: {
          extraInfo:
            'Това ще даде на Vault разрешение да подаде доклад или да зададе въпрос, директно към вашата организация, от Slack.',
          heading: 'Подайте доклад или въпрос от ваше име',
        },
        successfulConnectionDescription:
          'Вашият Vault акаунт и Slack акаунт вече са свързани. Можете да затворите този раздел и да се върнете към Slack.',
        successfulConnectionHeading: 'Успешно свързан',
        unsuccessfulConnectionDescription:
          'Нещо се обърка. Моля, затворете този раздел и се върнете към Slack, за да опитате отново.',
        unsuccessfulConnectionHeading: 'Свързването не бе успешно',
      },
      ReportingForgotPassword: {
        description:
          'Въведете имейл адреса, асоцииран с вашия акаунт, и ние ще ви изпратим връзка за възстановяване на паролата ви.',
        heading: 'Забравена парола',
        invalidTokenError: 'Не може да се създаде парола, невалиден токен.',
        passwordReuseError: 'Не е разрешено повторното използване на парола',
        passwordReuseErrorDescription:
          'За вашата сигурност, не можете да използвате някоя от последните си шест пароли. Моля, изберете нова, уникална парола, за да поддържате профила си в безопасност и опитайте отново.',
        sendLink: 'Изпратете връзка за нулиране',
        sendLinkFailure: 'Нещо се обърка',
        sendLinkFailureDescription:
          'Върнете се обратно в <a>Централа за репортажи</a> и опитайте отново. Ако проблемът продължи, свържете се с нас на <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Линк за нулиране на паролата е изпратен',
        sendLinkSuccessDescription:
          'Изпратихме връзка за възстановяване на паролата до {{email}}',
        updatePasswordSuccess: 'Паролата е обновена',
        updatePasswordSuccessDescription:
          'Вашата парола беше успешно обновена. Благодарим ви, че предприехте тази стъпка, за да запазите вашите данни в безопасност!',
      },
      ReportingLogin: {
        accountFrozen: 'Акаунтът е замразен',
        accountLocked:
          'Входът е опитан твърде много пъти неправилно. Акаунтът е заключен за до 1 час. Промяна на паролата не е възможна през това време.',
        accountLockedPermanently:
          'Вашият акаунт е блокиран. Използвайте възстановяването на паролата, за да възстановите достъпа или се свържете със системния администратор за допълнителна помощ.',
        createAccountCTA: 'Регистрирайте се за акаунт',
        currentPassword: 'Текуща парола',
        emailLabel: 'Вашият имейл',
        forgotPassword: 'Забравена парола?',
        loginButton: 'Вход',
        newPasswordPlaceholder: 'Нова парола',
        passwordFailMessage:
          'Върнете се обратно към приложението Vault в Slack и опитайте отново. Ако проблемът продължи, свържете се с нас на techsupport@vaultplatform.com',
        passwordFailTitle: 'Нещо се обърка',
        passwordLabel: 'Вашата парола',
        passwordPlaceholder: 'Въведете вашата парола',
        passwordResetRequired: 'Изисква се възстановяване на паролата',
        passwordSuccessfullySetMessage:
          'Върнете се към приложението Vault в Slack и се удостоверете с новата си парола, за да продължите от мястото, на което сте спрели.',
        passwordSuccessfullySetTitle: 'Паролата беше успешно зададена',
        reenterPlaceholder: 'Повторете паролата',
        title: 'Репортер Хъб',
        tooltip:
          'Ако никога до сега не сте задавали парола за приложението Vault, следвайте тези стъпки за да започнете. Ако сте забравили паролата си, използвайте връзката "Забравена парола" по-долу.',
        usernameLoginFailed:
          'Входът беше неуспешен, потребителското име или паролата са грешни',
      },
      ReportingReset: {
        failureDescription:
          'Върнете се обратно към Vault приложението в Slack и опитайте отново. Ако проблемът продължава, свържете се с нас на <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Нещо се обърка',
        successDescription:
          'Върнете се обратно в приложението Vault в Slack и се удостоверете с новата си парола, за да продължите оттам, където сте спрели.',
        successHeading: 'Паролата беше успешно зададена',
      },
      noReports: {
        description:
          'Всички подадени доклади ще се показват тук. Научете повече за начините, по които можете да подадете доклад в',
        descriptionHelpArticle: 'тази помощна статия',
        errorDescription:
          'Имаме проблем с зареждането на вашите доклади. Моля, опитайте да обновите страницата.',
        errorDescriptionSecondary:
          'Ако това не работи, моля свържете се с нас на',
        errorTitle: '⚠️ Опа, нещо се обърка',
        title: 'Все още нямате доклади',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Активирайте автоматичните преводи и четете всички съобщения от доклада на предпочитания от вас език. Преведеният език се базира на езика, избран на вашето устройство.',
          autoTranslationDescription2:
            'Можете да превключвате между преведения и оригиналния език във всяка чат сесия.',
          autoTranslationTitle:
            'Активирайте автоматичните преводи за съобщенията в доклада',
          header: 'Настройки на съобщенията',
          subHeader: 'Настройте как се показват съобщенията',
        },
        notificationSettings: {
          emailDescription:
            'Получавайте известия по имейл за важни актуализации на вашите отчети',
          emailTitle: 'Известия по имейл',
          header: 'Настройки за известия',
          subHeader: 'Конфигурирайте как да получавате известия',
        },
        title: 'Настройки',
        updatedSettingsFailure: 'Неуспешно актуализиране на вашите настройки',
        updatedSettingsSuccess: 'Успешно актуализирахте настройките си',
      },
    },
    validators: {
      passwordLength: 'Дължината на паролата трябва да е поне 9 символа',
      passwordLowercase: 'Паролата трябва да съдържа поне 1 малка буква',
      passwordMissMatch:
        'Полетата за парола и потвърждение трябва да съвпадат.',
      passwordNumeric: 'Паролата трябва да съдържа поне 1 цифра',
      passwordUppercase: 'Паролата трябва да съдържа поне 1 главна буква.',
    },
    validatorsNew: {
      passwordLength: 'Между 10 и 30 символа',
      passwordLowercase: 'Поне една малка буква',
      passwordMissMatch: 'Паролите не съвпадат',
      passwordNumeric: 'Поне едно число',
      passwordSpecialCharacter: 'Поне един специален символ',
      passwordUppercase: 'Поне една главна буква',
    },
  },
};

export default translations;
